import {
  trim
} from '../String.lib';

export default function formatURL(url) {
  url = trim(url).replace(/http(s)*:\/\//gi, '');
  if (/localhost/i.test(url)) {
    return `http://${url.replace(/localhost/i, '127.0.0.1')}`;
  }
  return url ? `https://${url}` : String(url).trim();
}
